import React from "react";
import Button from "@material-ui/core/Button";



import logo from "../assets/logo.svg";




const Hero = () => (
  
  <div style={{ 
    backgroundImage: `url("https://signulationassets.s3.jp-tok.cloud-object-storage.appdomain.cloud/Signulation-background3.svg")`,
    backgroundSize: 'cover',
            overflow: 'hidden',
    
  }}>
    <img style={{paddingLeft: '40px', paddingTop:'10px'}} src="https://signulationassets.s3.jp-tok.cloud-object-storage.appdomain.cloud/Signulation-main-hero5.svg" alt="Signulation Hero Image" width="250" />
    <h1 style={{ color: 'white', paddingLeft: '30px', fontSize: '50px' }} className="mb-4">  WELCOME TO SIGNULATION</h1>

    <p style={{ color: 'lightblue', paddingLeft: '40px', fontSize: '25px' }} className="lead">
      Full-Blown ASL Translation Web Application
    </p>

    <div style={{ paddingLeft: '40px', paddingBottom: '40px'}}>
    <Button style={{ borderRadius: '50px', background: 'white', color: '#4020267', paddingLeft: '20px', paddingTop: '10px', fontSize: '20px' }}>
        <p style={{ paddingRight: '20px'}}> Learn More About Signulation </p>
     </Button>
     </div>
    
  </div>
);

export default Hero;
